export type ScriptDescriptor = {
  id: string;
  src: string;
};

/** One promise per id: every caller settles with the same load, and a failed load is retried next call. */
const inFlight = new Map<string, Promise<void>>();

export const loadScriptOnce = ({ id, src }: ScriptDescriptor) => {
  if (typeof window === 'undefined') return Promise.resolve();
  const pending = inFlight.get(id);
  if (pending) return pending;

  const promise = new Promise<void>((resolve, reject) => {
    const script = document.createElement('script');
    script.id = id;
    script.src = src;
    script.async = true;
    script.onload = () => resolve();
    script.onerror = () => {
      inFlight.delete(id);
      script.remove();
      reject();
    };
    document.body.appendChild(script);
  });
  inFlight.set(id, promise);
  return promise;
};
